export enum MyAccountTypes {
  GET_INFO_USER_REQUEST = '@my_account/GET_INFO_USER_REQUEST',
  GET_INFO_USER_SUCCESS = '@my_account/GET_INFO_USER_SUCCESS',
  GET_INFO_USER_FAILURE = '@my_account/GET_INFO_USER_FAILURE',
  DESTROY_USER_PREFERENCES_REQUEST = '@my_account/DESTROY_USER_PREFERENCES_REQUEST',
  DESTROY_USER_PREFERENCES_SUCCESS = '@my_account/DESTROY_USER_PREFERENCES_SUCCESS',
  DESTROY_USER_PREFERENCES_FAILURE = '@my_account/DESTROY_USER_PREFERENCES_FAILURE',
  CREATE_USER_PREFERENCES_REQUEST = '@my_account/CREATE_USER_PREFERENCES_REQUEST',
  CREATE_USER_PREFERENCES_SUCCESS = '@my_account/CREATE_USER_PREFERENCES_SUCCESS',
  CREATE_USER_PREFERENCES_FAILURE = '@my_account/CREATE_USER_PREFERENCES_FAILURE',
  UPDATE_NOTIFICACOES_FAILURE = '@my_account/UPDATE_NOTIFICACOES_FAILURE',
  GET_USERS_REQUEST = '@my_account/GET_USERS_REQUEST',
  GET_USERS_SUCCESS = '@my_account/GET_USERS_SUCCESS',
  GET_USERS_FAILURE = '@my_account/GET_USERS_FAILURE',
  GET_CURRENT_SALE_REQUEST = '@my_account/GET_CURRENT_SALE_REQUEST',
  GET_CURRENT_SALE_SUCCESS = '@my_account/GET_CURRENT_SALE_SUCCESS',
  GET_CURRENT_SALE_FAILURE = '@my_account/GET_CURRENT_SALE_FAILURE',
  GET_SCHEDULED_SALE_REQUEST = '@my_account/GET_SCHEDULED_SALE_REQUEST',
  GET_SCHEDULED_SALE_SUCCESS = '@my_account/GET_SCHEDULED_SALE_SUCCESS',
  GET_SCHEDULED_SALE_FAILURE = '@my_account/GET_SCHEDULED_SALE_FAILURE',
  GET_PENDING_INCOMES_REQUEST = '@my_account/GET_PENDING_INCOMES_REQUEST',
  GET_PENDING_INCOMES_SUCCESS = '@my_account/GET_PENDING_INCOMES_SUCCESS',
  GET_PENDING_INCOMES_FAILURE = '@my_account/GET_PENDING_INCOMES_FAILURE',
  GET_INCOMES_REQUEST = '@my_account/GET_INCOMES_REQUEST',
  GET_INCOMES_SUCCESS = '@my_account/GET_INCOMES_SUCCESS',
  GET_INCOMES_FAILURE = '@my_account/GET_INCOMES_FAILURE',
  GET_SCHEDULED_REQUEST = '@my_account/GET_SCHEDULED_REQUEST',
  GET_SCHEDULED_SUCCESS = '@my_account/GET_SCHEDULED_SUCCESS',
  GET_SCHEDULED_FAILURE = '@my_account/GET_SCHEDULED_FAILURE',
  GET_EDIT_USER_REQUEST = '@my_account/GET_EDIT_USER_REQUEST',
  GET_EDIT_USER_SUCCESS = '@my_account/GET_DIT_USER_SUCCESS',
  GET_EDIT_USER_FAILURE = '@my_account/GET_EDIT_USER_FAILURE',
  GET_SOLICITATION_EDITION_REQUEST = '@my_account/GET_SOLICITATION_EDITION_REQUEST',
  GET_SOLICITATION_EDITION_SUCCESS = '@my_account/GET_SOLICITATION_EDITION_SUCCESS',
  GET_SOLICITATION_EDITION_FAILURE = '@my_account/GET_SOLICITATION_EDITION_FAILURE',
  GET_SOLICITATION_ADDITION_REQUEST = '@my_account/GET_SOLICITATION_ADDITION_REQUEST',
  GET_SOLICITATION_ADDITION_SUCCESS = '@my_account/GET_SOLICITATION_ADDITION_SUCCESS',
  GET_SOLICITATION_ADDITION_FAILURE = '@my_account/GET_SOLICITATION_ADDITION_FAILURE',
  GET_SOLICITATION_LIST_REQUEST = '@my_account/GET_SOLICITATION_LIST_REQUEST',
  GET_SOLICITATION_LIST_SUCCESS = '@my_account/GET_SOLICITATION_LIST_SUCCESS',
  GET_SOLICITATION_LIST_FAILURE = '@my_account/GET_SOLICITATION_LIST_FAILURE',
  GET_MY_FILTERS_REQUEST = '@my_account/GET_MY_FILTERS_REQUEST',
  GET_MY_FILTERS_SUCCESS = '@my_account/GET_MY_FILTERS_SUCCESS',
  GET_MY_FILTERS_FAILURE = '@my_account/GET_MY_FILTERS_FAILURE',
  GET_BOLETOS_ONLINE_REQUEST = '@my_account/GET_BOLETOS_ONLINE_REQUEST',
  GET_BOLETOS_ONLINE_SUCCESS = '@my_account/GET_BOLETOS_ONLINE_SUCCESS',
  GET_BOLETOS_ONLINE_FAILURE = '@my_account/GET_BOLETOS_ONLINE_FAILURE',
  GET_UPDATE_SHORTCUTS_REQUEST = '@my_account/GET_UPDATE_SHORTCUTS_REQUEST',
  GET_UPDATE_SHORTCUTS_SUCCESS = '@my_account/GET_UPDATE_SHORTCUTS_SUCCESS',
  GET_UPDATE_SHORTCUTS_FAILURE = '@my_account/GET_UPDATE_SHORTCUTS_FAILURE',
  OPEN_EXCLUSION_MODAL = '@my_account/OPEN_EXCLUSION_MODAL',
  CLOSE_EXCLUSION_MODAL = '@my_account/CLOSE_EXCLUSION_MODAL',
  VIEW_COMPONENT = '@my_account/VIEW_COMPONENT',
  MODAL_SUCCESS = '@my_account/MODAL_SUCCESS',
}

export interface ContactClientTypes {
  ativo: boolean;
  ddd_celular: string;
  ddd_telefone: string;
  email: string;
  genre: {
    id: number;
    nome: string;
  };
  id: number;
  nome: string;
  numero_celular: string;
  numero_telefone: string;
  role: {
    id: number;
    nome: string;
  };
}

export interface UserTypes {
  contact_client: ContactClientTypes;
  id: number;
  email: string;
  nome: string;
  ativo: boolean;
}

export interface UsersTypes {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
}

export interface CurrentSaleTypes {
  id: number;
  inicio: string;
  fim: string;
}

export interface PaymentSituationTypes {
  venda_id: number;
  receitas_pendentes: number;
}

export interface SolicitationListTypes {
  id: number;
  protocolo: string;
  created: string;
  status_id: number;
}

export interface PeriodosTypes {
  manha: string;
  noite: string;
  tarde: string;
}

export interface BiddingTypes {
  atividades: {
    is_negation: boolean;
    values: string;
  };
  estados: {
    is_negation: boolean;
    values: string;
  };
  palavra_chave: {
    is_negation: boolean;
    values: string;
  };
}

export interface FollowupsTypes {
  atividades: {
    is_negation: boolean;
    values: string;
  };
  estados: {
    is_negation: boolean;
    values: string;
  };
  palavra_chave: {
    is_negation: boolean;
    values: string;
  };
}

export interface IncomeTypes {
  descricao: string;
  valor: number;
  desconto: number;
  parcela: number;
  data_vencimento: string;
  situacao_receita_id: number;
  data_pagamento: string;
  id: number;
}

export interface MyFiltersTypes {
  nome_filtro: string;
  users: string;
  periodos: Array<PeriodosTypes>;
  licitacao: Array<BiddingTypes>;
  acompanhamento: Array<FollowupsTypes>;
}

export interface AccountTypes {
  user: UserTypes;
  has_register_in_authentication: boolean;
  documents_push_notification: boolean;
  documents_email_notification: boolean;
  documents_notification: boolean;
  eligible_beta_tester_program: boolean;
  no_bulletin_email_notification: boolean;
  no_bulletin_push_notification: boolean;
  beta_tester: boolean;
  no_notification_bw: boolean;
  notification_status: boolean;
  notification_nome: string;
  users: Array<UsersTypes>;
  current_sale: {
    servicos_planos_vendas: Array<CurrentSaleTypes>;
    valor_total: string;
    valor_variacao_forma_pagamento: string;
    formas_pagamento: {
      nome: string;
    };
    parcelas: string;
    id: number;
    status_pagamento: Array<PaymentSituationTypes>;
  };
  status_pagamento: boolean;
  valor_parcela: string;
  scheduled_sale: {
    id: number;
    valor_total: string;
    servicos_planos_vendas: Array<CurrentSaleTypes>;
    valor_variacao_forma_pagamento: string;
    formas_pagamento: {
      nome: string;
    };
    parcelas: number;
    status_pagamento: Array<PaymentSituationTypes>;
  };
  cargo_name: string;
  email: string;
  name: string;
  cel_ddd: string;
  cel_number: string;
  return_modal_sucesso: boolean;
  exclusionModal: boolean;
  solicitation_list: Array<SolicitationListTypes>;
  my_filters: Array<MyFiltersTypes>;
  filters_client: Array<MyFiltersTypes>;
  users_filters: Array<string>;
  incomes: Array<IncomeTypes>;
  future_sale_invoice_incomes: Array<IncomeTypes>;
  viewComponent: string;
  modalSuccess: boolean;
}

export interface RequestState {
  get_info_user: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  destroy_user: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  create_user: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  users: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  user_add: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  current_sale: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };

  scheduled_sale: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  pending_incomes: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_incomes: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  edit_user: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  solicitation_edition: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  solicitation_list: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  my_filters: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  incomes: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface MyAccountState {
  my_account: AccountTypes;
  readonly request: RequestState;
}
